import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.scss';
import './assets/styles/fonts.scss';

ReactDOM.render(<App />, document.getElementById('root'));
